/*
NOTE: This file currently implements a lot of the functionality we look for using
the `browser` gem (https://github.com/fnando/browser). Ideally, we should be checking
for the existance of _specific_ functionality, not the state of the browser. That way
we can progressively enhance a user's experience as their browser updates.
*/

const CHROMIUM = window.chrome;
const WIN_NAV = window.navigator;
const VENDOR_NAME = WIN_NAV.vendor;
const OPERA = typeof window.opr !== 'undefined';
const MSIE = WIN_NAV.userAgent.indexOf('MSIE ') > -1;
const IE = WIN_NAV.userAgent.indexOf('Trident/') > -1;
const IE_EDGE = WIN_NAV.userAgent.indexOf('Edge') > -1;
const IOS_CHROME = WIN_NAV.userAgent.match('CriOS');
const IOS_FIREFOX = WIN_NAV.userAgent.match('FxiOS');
const APPLE_SAFARI = VENDOR_NAME.indexOf('Apple') > -1;
const FIREFOX = WIN_NAV.userAgent.indexOf('Firefox') > -1;

// https://coderwall.com/p/i817wa/one-line-function-to-detect-mobile-devices-with-javascript
export const isMobileDevice = () =>
  typeof window.orientation !== 'undefined' ||
  navigator.userAgent.indexOf('IEMobile') !== -1;

// https://stackoverflow.com/questions/4565112/javascript-how-to-find-out-if-the-user-browser-is-chrome/13348618#13348618
export const isChrome = () =>
  CHROMIUM !== null &&
  typeof CHROMIUM !== 'undefined' &&
  VENDOR_NAME === 'Google Inc.' &&
  OPERA === false &&
  IE_EDGE === false;

// https://stackoverflow.com/a/31732310/1466592
export const isSafari = () =>
  Boolean(APPLE_SAFARI && !IOS_CHROME && !IOS_FIREFOX);

// https://stackoverflow.com/a/21712356/1466592
export const isIE = () => MSIE || IE || IE_EDGE;

export const isFirefox = () => FIREFOX;
